import { Inject, Injectable } from '@angular/core';
import {
  ApiResourceLocation,
  ResourceService,
  SOFTLINE_SERVICE_HTTP,
} from '@softline/core';
import { Observable, switchMap } from 'rxjs';
import { Einheiteneingabe } from '../types/einheiteneingabe';
import {
  SOFTLINE_API_WWS_EINHEITENEINGABE,
  SOFTLINE_API_WWS_EINHEITENEINGABE_UMRECHNEN,
} from '../einheiteneingabe.api';
import { map } from 'rxjs/operators';

@Injectable()
export class EinheiteneingabeService {
  private umrechnenLocation(idmasseinheitd?: number): ApiResourceLocation {
    return {
      path: SOFTLINE_API_WWS_EINHEITENEINGABE_UMRECHNEN,
      queryParams: idmasseinheitd ? { idmasseinheitd } : undefined,
    };
  }

  constructor(
    @Inject(SOFTLINE_SERVICE_HTTP)
    private readonly httpService: ResourceService<ApiResourceLocation>
  ) {}

  initialisierenOnly(params: {
    idartstamm: number;
    menge?: number;
    idbasisEinheit: number;
    idarteheingabe?: number;
  }): Observable<Einheiteneingabe> {
    return this.httpService
      .get<Einheiteneingabe>(
        this.initialisierenLocation(params.idartstamm, params?.idarteheingabe)
      )
      .pipe(
        map((value) => {
          const einheiten = [...value.einheiten];

          return {
            ...value,
            einheiten,
            ideinheitEingabe: params.idbasisEinheit,
          } as Einheiteneingabe;
        })
      );
  }

  initialisieren(params: {
    idartstamm: number;
    menge?: number;
    idbasisEinheit: number;
    idarteheingabe?: number;
  }): Observable<Einheiteneingabe> {
    return this.initialisierenOnly(params).pipe(
      map((value) => {
        const einheiten = [...value.einheiten];

        if (value && value.erfassungsEinheit?.menge) {
          const index = einheiten.findIndex(
            (e) => e.einheit.id === value.erfassungsEinheit.einheit.id
          );
          einheiten[index] = value.erfassungsEinheit;

          for (let i = 0; i < einheiten.length; i++) {
            if (einheiten[i].einheit.id === value?.erfassungsEinheit?.einheit.id) {
              einheiten[i].menge = value?.erfassungsEinheit?.menge ?? 0;
            } else {
              einheiten[i].menge = null;
            }
          }
        }

        return {
          ...value,
          einheiten,
          ideinheitEingabe: params.idbasisEinheit,
          erfassungsEinheit: {
            einheit: { id: params.idbasisEinheit },
            menge: 0,
          },
        } as Einheiteneingabe;
      }),
      switchMap((value) => this.umrechnen(value))
    );

    /*
return this.httpService
.get<Einheiteneingabe>(
this.initialisierenLocation(params.idartstamm, params?.idarteheingabe)
)
.pipe(
map((value) => {
 const einheiten = [...value.einheiten];


 for (const einheit of einheiten) {
   if (params?.idarteheingabe !== undefined) {
     const unit = value.einheiten.find(
       (o) => einheit.einheit.id === o.einheit.id
     );
     if (!unit) continue;
     einheit.menge = unit?.menge ?? 0;
   } else {
     if (einheit.einheit.id !== params.idbasisEinheit) continue;
     einheit.menge = params?.menge ?? 0;
   }
 }


          return {
            ...value,
            einheiten,
            ideinheitEingabe: params.idbasisEinheit,
            erfassungsEinheit: {
              einheit: { id: params.idbasisEinheit },
              menge: params?.menge ?? 0,
            },
          } as Einheiteneingabe;
        }),
        switchMap((value) => this.umrechnen(value))
      );
      */
  }

  umrechnen(
    einheiteneingabe: Einheiteneingabe,
    idmasseinheitd?: number
  ): Observable<Einheiteneingabe> {
    return this.httpService.create(
      this.umrechnenLocation(idmasseinheitd),
      einheiteneingabe
    );
  }

  private initialisierenLocation(
    id: number,
    idaretheingabe?: number
  ): ApiResourceLocation {
    return {
      path: idaretheingabe
        ? `${SOFTLINE_API_WWS_EINHEITENEINGABE}/${idaretheingabe}`
        : SOFTLINE_API_WWS_EINHEITENEINGABE,
      pathParams: { id },
    };
  }
}
